export default {
  JOB_LIST_SINGLE: 'single',
  JOB_LIST_RECURRING: 'recurring'
}
